import { toastManager } from '@systemeio/components'
import { useTranslation } from 'next-i18next'
import { MAX_UPLOAD_FILES } from 'shared/constants'

export const useMultipleFileUpload = (): {
  handleMultipleFileUpload: (
    files: File[],
    onUpload: (file: File) => Promise<void>,
  ) => Promise<void>
} => {
  const { t } = useTranslation()

  const handleMultipleFileUpload = async (
    files: File[],
    onUpload: (file: File) => Promise<void>,
  ): Promise<void> => {
    let filesToUpload = files

    if (files.length > MAX_UPLOAD_FILES) {
      toastManager.add({
        type: 'error',
        title: t('post.attachments.file_upload.max_files_exceeded', {
          max: MAX_UPLOAD_FILES,
        }),
      })
      filesToUpload = files.slice(0, MAX_UPLOAD_FILES)
    }

    await Promise.all(filesToUpload.map(file => onUpload(file)))
  }

  return { handleMultipleFileUpload }
}
